var _style, _path, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSexualHealth({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 113.4 113.4",
    style: {
      enableBackground: "new 0 0 113.4 113.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F5E9DA;}\n\t.st1{fill:#CF7494;}\n\t.st2{fill:#618FCB;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.7,109.4c29.4,0,53.2-23.6,53.2-52.7S86.1,4,56.7,4S3.6,27.6,3.6,56.7S27.4,109.4,56.7,109.4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.6,61.8c-10.1,0-18.4-8.2-18.4-18.4S29.4,25,39.6,25S58,33.3,58,43.5S49.8,61.8,39.6,61.8z M52.8,43.5 c0-7.3-5.9-13.2-13.2-13.2s-13.2,5.9-13.2,13.2s6,13.1,13.2,13.1S52.8,50.7,52.8,43.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.8,
    y: 60.5,
    className: "st1",
    width: 5.7,
    height: 23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.9,
    y: 67.4,
    className: "st1",
    width: 27.4,
    height: 5.7
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M68.7,87.4c-10.1,0-18.3-8.2-18.3-18.3s8.2-18.4,18.4-18.4s18.3,8.2,18.3,18.4S78.9,87.4,68.7,87.4z  M81.9,69.1c0-7.3-5.9-13.2-13.2-13.2c-7.3,0-13.2,5.9-13.2,13.2c0,7.3,5.9,13.2,13.2,13.2C76,82.3,81.9,76.3,81.9,69.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.4,
    y: 50.4,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -13.1366 74.847)",
    className: "st2",
    width: 14.7,
    height: 5.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "82.6,42.4 94.5,54.4 95.6,41.2  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSexualHealth);
export default __webpack_public_path__ + "static/media/Sexual_Health.26b47ec98da75ba91c3fd93bce7dce4a.svg";
export { ForwardRef as ReactComponent };